import React from "react";
import { Exhibit } from "../Exhibit";
import { SectionLabel } from "../SectionLabel";
import { MaturityProfile } from "../fragments/MaturityProfile";
import { IssueDistribution } from "./IssueDistribution";
import { PercentileBenchmark } from "./PercentileBenchmark";
export function ResearchFindings() {
  return <section id="findings" aria-labelledby="findings-title" className="scroll-mt-28 border-t border-stone" data-id="element-559" data-mp="21o6g2cvaocs9">
      <div className="shell py-24 md:py-32" data-id="element-560" data-mp="142sgnziax1vx">
        <div className="grid grid-cols-12 gap-x-6 gap-y-8 pb-16" data-id="element-561" data-mp="190k5gknng7vw">
          <div className="col-span-12 lg:col-span-3 lg:pt-3" data-id="element-562" data-mp="190tx0cocen3p">
            <SectionLabel data-id="element-563" data-mp="1dzdgm6fgrmsw">Findings</SectionLabel>
          </div>
          <div className="col-span-12 lg:col-span-9" data-id="element-564" data-mp="1iqdepf0bkawz">
            <h2 id="findings-title" className="font-display text-[clamp(2.25rem,4.6vw,4rem)] leading-[1.05] text-navy" data-id="element-565" data-mp="1ir594mi6k2lo">
              What the evidence says so far.
            </h2>
            <p className="mt-6 max-w-xl leading-relaxed text-charcoal/75" data-id="element-566" data-mp="q9122cppqrtc">
              Preliminary figures from Constant’s field work and the 2026 study, now in collection. Final data and
              method publish with the report.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-x-6 gap-y-20" data-id="element-567" data-mp="1s856u6rjndb0">
          <Exhibit className="col-span-12 lg:col-span-7" label="Exhibit 1" title="Where payroll and HR technology problems originate" source="Share of root causes across issues logged in Constant engagements. Preliminary." data-id="element-568" data-mp="1s6kcah58bud5">
            <IssueDistribution data-id="element-569" data-mp="1e7ko1almphhi" />
          </Exhibit>

          <aside aria-label="Report excerpt" className="col-span-12 lg:col-span-4 lg:col-start-9" data-id="element-570" data-mp="1999fr4azff1e">
            <div className="border-t-2 border-oxblood pt-5" data-id="element-571" data-mp="14b7tybm691m8">
              <p className="eyebrow text-oxblood" data-id="element-572" data-mp="14csoi18hkkk3">From the report · p. 14</p>
              <p className="mt-8 font-display text-[clamp(4rem,7vw,6rem)] leading-none text-oxblood" data-id="element-573" data-mp="33nae7o2me00y">3 in 5</p>
              <p className="mt-6 font-display text-2xl italic leading-snug text-navy" data-id="element-574" data-mp="2ypio8zljcnze">
                HRIS implementations we reviewed went live with at least one configuration error that affected pay.
              </p>
              <p className="mt-8 border-t border-stone pt-4 text-xs leading-relaxed text-charcoal/60" data-id="element-575" data-mp="n1drfagrgqln">
                The State of Payroll Operations, 2026 — Chapter 2: HRIS implementations, eighteen months after go-live.
              </p>
              <a href="#state-of-payroll" className="link-rule mt-8" data-id="element-576" data-mp="1fr2t7q1aouob">
                Request the report
              </a>
            </div>
          </aside>

          <Exhibit className="col-span-12 lg:col-span-7" label="Exhibit 2" title="Benchmarks: the middle of the market, and the best-run functions" source="Illustrative ranges. Benchmark dataset in collection; Stage IV+ refers to the Payroll Maturity Model™." data-id="element-577" data-mp="16pd3qpqz45t6">
            <PercentileBenchmark data-id="element-578" data-mp="3vhp28ge7267z" />
          </Exhibit>

          <Exhibit className="col-span-12 lg:col-span-4 lg:col-start-9" label="Exhibit 3" title="A maturity profile, scored by dimension" data-id="element-579" data-mp="3vf2twejhbmop">
            <MaturityProfile data-id="element-580" data-mp="3iy1wi2dg8m0q" />
          </Exhibit>
        </div>
      </div>
    </section>;
}